import React from 'react';

class TimeSelect2 extends React.Component {
  render() {
    return (
      <optgroup>
        <option value="00:00">12:00am</option>
        <option value="00:30">12:30am</option>
        <option value="01:00">1:00am</option>
        <option value="01:30">1:30am</option>
        <option value="02:00">2:00am</option>
        <option value="02:30">2:30am</option>
        <option value="03:00">3:00am</option>
        <option value="03:30">3:30am</option>
        <option value="04:00">4:00am</option>
        <option value="04:30">4:30am</option>
        <option value="05:00">5:00am</option>
        <option value="05:30">5:30am</option>
        <option value="06:00">6:00am</option>
        <option value="06:30">6:30am</option>
        <option value="07:00">7:00am</option>
        <option value="07:30">7:30am</option>
        <option value="08:00">8:00am</option>
        <option value="08:30">8:30am</option>
        <option value="09:00">9:00am</option>
        <option value="09:30">9:30am</option>
        <option value="10:00">10:00am</option>
        <option value="10:30">10:30am</option>
        <option value="11:00">11:00am</option>
        <option value="11:30">11:30am</option>
        <option value="12:00">12:00pm</option>
        <option value="12:30">12:30pm</option>
        <option value="13:00">1:00pm</option>
        <option value="13:30">1:30pm</option>
        <option value="14:00">2:00pm</option>
        <option value="14:30">2:30pm</option>
        <option value="15:00">3:00pm</option>
        <option value="15:30">3:30pm</option>
        <option value="16:00">4:00pm</option>
        <option value="16:30">4:30pm</option>
        <option value="17:00">5:00pm</option>
        <option value="17:30">5:30pm</option>
        <option value="18:00">6:00pm</option>
        <option value="18:30">6:30pm</option>
        <option value="19:00">7:00pm</option>
        <option value="19:30">7:30pm</option>
        <option value="20:00">8:00pm</option>
        <option value="20:30">8:30pm</option>
        <option value="21:00">9:00pm</option>
        <option value="21:30">9:30pm</option>
        <option value="22:00">10:00pm</option>
        <option value="22:30">10:30pm</option>
        <option value="23:00">11:00pm</option>
        <option value="23:30">11:30pm</option>
      </optgroup>
    )
  }
}

export default TimeSelect2;



// WEBPACK FOOTER //
// ./src/app/components/Modules/TimeSelect2.js